import { useState, useEffect } from "react";
import { getGlobalMaterials } from "../../dataApi/getGlobalMaterials";

export default () => {
  const [allOrgSections, setAllOrgSections] = useState<
    { material_id: string; name: string }[]
  >();
  const [loading, setLoading] = useState<boolean>(false);

  // fetch master list data
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const data = await getGlobalMaterials();

        setAllOrgSections(data);
        setLoading(false);
      } catch (e) {
        console.error(e);
        setLoading(false);
      }
    })();
  }, []);

  return { allOrgSections, loading };
};
